// links: optional [{ label, url }] rendered as buttons under the card
export const EXPERIENCE = [
  {
    id: 'earnie',
    company: 'Teli.ai — Earnie V2',
    role: 'Full Stack Engineer · Employee Rewards & Gamification Platform',
    period: 'Jan 2026 — Present',
    location: 'Southfield, MI',
    tags: ['React', 'TypeScript', 'Hono', 'Supabase Edge', 'PostgreSQL', 'REST APIs', 'Payments', 'Stripe', 'Salesforce'],
    bullets: [
      'Architected and shipped a multi-tenant SaaS platform from scratch — ~115K LOC across React 18/TypeScript, Hono on Supabase Edge Functions, and PostgreSQL — spanning 100+ REST endpoints, 95+ migrations, and 130+ React components in under four months.',
      'Designed a three-tier RBAC model (Super Admin → Org Admin → Employee) enforced via Postgres Row-Level Security on every tenant-scoped table, with a header-driven cross-org super-admin path and zero cross-tenant data leaks across all production organizations.',
      'Engineered a CRM-integrated KPI reward engine with Salesforce OAuth + token refresh, three configurable pause-and-replay strategies for missed thresholds (forward-only, current-window catch-up, full retroactive drain), and a templated integration layer for HubSpot/Zoho.',
      'Delivered six gamification modules end-to-end — Challenges, Battles, Power Wheel, Spin Wheel, March Madness brackets, and Shoutouts — plus a real-time Live Activity feed via Supabase Realtime, Stripe billing, Mailgun transactional email, and Supabase MFA with forced first-login flows.',
    ],
    links: [{ label: 'earniexp.com ↗', url: 'https://earniexp.com/' }],
  },
  {
    id: 'winitall',
    company: 'Teli.ai — Win It All',
    role: 'Full Stack Engineer · Real-Money Sports Pool Betting Platform',
    period: 'Jan 2026 — Present',
    location: 'Southfield, MI',
    tags: ['Flutter', 'Kotlin', 'Spring Boot 3.4', 'React', 'REST APIs', 'Payments', 'PaySafe', 'Azure', 'Terraform', 'Redis'],
    bullets: [
      'Inherited and refactored a broken 9-repository codebase — a Flutter app (iOS/Android/Web), Kotlin/Spring Boot 3.4 REST API, a dedicated Spring scheduler microservice, a React/Refine admin panel, and Azure Terraform infra — stabilizing and scaling it to production readiness.',
      'Built a fraud-resistant geofencing pipeline using Radar verified-location JWTs injected via a Flutter Dio interceptor; the Spring backend validates HMAC signatures and rejects VPN/proxy/mocked-GPS claims before authorizing any money movement.',
      'Implemented end-to-end payments and KYC — PaySafe (cards, Apple Pay, Google Pay, 3DS) with reservation-based wallet accounting and an async checkout state machine (PENDING → COMPLETED / ONHOLD / DENIED), plus a full GBG identity flow with 5-state validation and Zendesk escalation.',
      'Extracted 17 timezone-aware cron jobs into a dedicated Spring Boot scheduler (America/New_York) covering pool state transitions, 60-minute NFL/NBA/MLB/CBB score syncs via SportsData.io, and 5-minute pending-withdrawal reconciliation — layered with Azure Redis (60s TTL) to absorb game-window spikes.',
    ],
    links: [{ label: 'winitall.com ↗', url: 'https://www.winitall.com/' }],
  },
  {
    id: 'idtech',
    company: 'iD Tech · Stanford University',
    role: 'Java & C++ Instructor',
    period: 'Jun — Aug 2025',
    location: 'Stanford, CA',
    tags: ['Java', 'C++', 'Raylib', 'Teaching'],
    bullets: [
      'Designed and delivered a 10-week curriculum in Java and C++ (with Raylib) to 40+ students, focused on iterative design, debugging, and modularity.',
      'Mentored students aged 10–12 in BattleBots robotics, guiding them in programming and customizing robot behavior in C++.',
    ],
    links: [],
  },
  {
    id: 'whitman',
    company: 'Whitman College',
    role: 'Software Developer & Research Assistant · Chemistry, Biology, and CS Departments',
    period: 'Jun 2023 — May 2025',
    location: 'Walla Walla, WA',
    tags: ['Python', 'Java', 'R', 'Shiny', 'GUI Design', 'Automation', 'Data Visualization'],
    bullets: [
      'Led the capstone Lab Automation project for the Chemistry Dept. — owned the full lifecycle from requirements to delivery and built a GUI that removed the command-line barrier for a robotic chemical synthesis system.',
      'Analyzed student-athlete cognitive data for the Biology Dept. using R and ggplot2 to identify concussion indicators, delivering findings through interactive Shiny apps that informed new safety protocols.',
      'Built the PFAS Governance Database search interface for the CS Dept., serving 500+ users and cutting average search time by 25% while raising engagement by 30%.',
    ],
    links: [],
  },
];
